import React from 'react'
import { useNavigate } from 'react-router-dom'
import OurServicesSection from 'pages/WelcomePage/components/WelcomeSections/OurServicesSection/OurServicesSection'
import styles from './ServicesPage.module.scss'

const ServicesPage = () => {
  const navigate = useNavigate()

  return (
    <div className={styles.wrapper}>
      <OurServicesSection onOpenService={(id) => navigate('/services/' + id)} />
    </div>
  )
}

export default ServicesPage
